export default __webpack_public_path__ + "static/media/ic2.70f8cb9c.svg";